import React, { useEffect, useContext } from 'react';
import { RouterContext, PreferenceContext } from '../context';
import { scrollToTop } from '../../lib/helpers';

export const ScrollToTop = ({ children }) => {
  const route = useContext(RouterContext);
  const isItemModal =
    (route.to.includes('selectedId=') || (route.from && route.from.includes('selectedId='))) &&
    !route.to.includes('tag');
  const {
    preference: { nsfwActive, filter },
  } = useContext(PreferenceContext);

  useEffect(() => {
    if (!isItemModal) {
      scrollToTop();
    }
  }, [Object.values(route).join(), nsfwActive, filter]);

  return <>{children}</>;
};
